import Api from 'utils/api'
import { buildUrl } from 'utils/helpers'
import * as actions from './actions'

// localities

export const getAdminLocalities =
  ({ page, limit, q, country_code }) =>
  async (dispatch) => {
    dispatch(actions.getLocalitiesRequest())
    try {
      const result = await Api.request(
        buildUrl(`/admin/localities`, { q, page, limit, country_code })
      )

      dispatch(actions.getLocalitiesSuccess(result))
      return Promise.resolve(result)
    } catch (err) {
      const { error } = await err.json()
      dispatch(actions.getLocalitiesError(error))
      return Promise.reject(err)
    }
  }
